export const getAuthHeader = () => {
  // For API requests outside of DataProvider context
  const auth = JSON.parse(localStorage.getItem('dhis2-auth'));
  return auth ? { 'Authorization': `Basic ${btoa(`${auth.username}:${auth.password}`)}` } : {};
};

export const storeAuth = (username, password) => {
  localStorage.setItem('dhis2-auth', JSON.stringify({ username, password }));
};

export const clearAuth = () => {
  localStorage.removeItem('dhis2-auth');
};
  
export const isAuthenticated = () => {
  return localStorage.getItem('dhis2-auth') !== null;
};

export const fetchCurrentUserOrgUnit = async (engine) => {
    const { me } = await engine.query({
        me: {
            resource: 'me',
            params: {
                fields: 'organisationUnits[id,name]'
            }
        }
    });

    const ou = me.organisationUnits?.[0];
    if (!ou) throw new Error("No organisation unit found for current user");

    return { id: ou.id, name: ou.name };
};


export function logout(navigate) {
  clearAuth();
  navigate('/login');
  window.location.reload();
}